import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-TS-logo_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 47.9 52.4"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-TS-logo_svg__cls-1{fill:#00b3f0}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M8.1 38.3c2-4.9 5.9-11.6 8.3-14.8-3.3-2.7-9.5-5.6-9.5-5.6s4.9-2.1 14.7-2.6c0 0 4.1-7.9 14.6-15.3-6.4 2-12.4 7.5-18.5 13.4-7.8.4-16.3 3.5-17.2 4 9 4.7 11.2 6.8 11.2 6.8s-3 8.6-3.6 14.1ZM47.9 18.3c-7.7-3.1-17.1-3.9-17.1-3.9s-.2-2.4.5-7.1c-.9 1.9-2.5 6.1-2.8 9.2 6.9.5 11.6 2.1 11.6 2.1s-7 2.6-10.9 5.7c.7 1.7 2.3 6.7 3.2 10.6-1.5-1.4-6-5.1-9.3-7.1C18.7 29.5 6.7 41.4 0 52.4c2.9-3 11.5-12.7 23.1-19.7 2.4 1.4 13.4 8.6 13.4 8.6s-2.4-12.8-3.3-15.8c3.4-2.3 9.2-5.5 14.7-7.2Z",
      class: "svg-TS-logo_svg__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "TS-logo"}) } }